import {BaseContainerModel} from "../../../base-container.model";
import {bl_alg_cc_template_message_placeholder_hdr_RowClass} from "../../../../dbschema";

export class TemplateMessagePlaceholderContainerModel extends BaseContainerModel {
  bl_alg_cc_template_message_placeholder_hdr: bl_alg_cc_template_message_placeholder_hdr_RowClass = new bl_alg_cc_template_message_placeholder_hdr_RowClass();
}
